// @ts-strict-ignore
import { JsonObject, JsonProperty } from '../convert/convert-core';
import { PropertyInLocalesVO } from '@project/components/article/model/vo/property.vo';

@JsonObject('NotificationVO')
export class NotificationVO {

    @JsonProperty('location', 'String')
    public location: string = undefined;

    @JsonProperty('startDate', 'DateConverter', true)
    public startDate: Date = undefined;

    @JsonProperty('endDate', 'DateConverter', true)
    public endDate: Date = undefined;

    @JsonProperty('value', 'PropertyInLocalesVO')
    public value: PropertyInLocalesVO = undefined;
}
